
/*
 * Mahj & Marlowe - Horizon native cart drawer reliability bridge.
 *
 * Horizon already opens the drawer on cart:update. On mobile the same event
 * also refreshes the header section, so this second, post-render open keeps the
 * dialog reliable without opening it for failed add-to-cart requests.
 */

(function () {
  function openNativeCartDrawer() {
    const drawer = document.querySelector('cart-drawer-component[auto-open]');
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  document.addEventListener('cart:update', function (event) {
    const data = event.detail && event.detail.data;
    const isSuccessfulProductAdd = data && data.source === 'product-form-component' && data.didError !== true;

    if (!isSuccessfulProductAdd) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(openNativeCartDrawer);
    });
  });
})();
